<template>
    <div class="ak-relation-data-table d-flex flex-column full-height">
        <ak-data-table
            ref="dataTable"
            :bundle="bundle"
            :definition="definition"
            :relation="relation"
            :idsSelected="defaultIdsSelected"
            :infiniteScroll="false"
            :query="queryForRelationTable"
            :compactFilters="true"
            @selectionChanged="updateSelection"
            @edit="updateRelationString"
            @new="updateRelationString"
        >
            <template v-if="isListView" v-slot:default="slotProps">
                <ak-data-list
                    :dataObjects="slotProps.dataObjects"
                    :selectables="slotProps.selectables"
                    :selection="slotProps.selection"
                    :isUpdating="slotProps.isUpdating"
                    :sortingEnabled="slotProps.sortingEnabled"
                    :pageJumper="slotProps.pageJumper"
                    :widgetCallbackUri="slotProps.baseGridUri"
                    :numberOfTilesPerRow="slotProps.numberOfTilesPerRow"
                    @edit="slotProps.handleEdit"
                    @delete="slotProps.handleDelete"
                    @sortColumn="slotProps.sortColumn($event)"
                    @changeList="slotProps.dataObjects = $event"
                    @sort="slotProps.submitNewSorting($event)"
                    @refresh="slotProps.refresh"
                    @export="slotProps.triggerExport"
                />
            </template>

            <template
                v-slot:idle-widgets="{idleWidgets, baseGridUri, handleNew, contextualPageJumperWidgets}"
            >
                <div class="ak-data-table__idle-widgets">
                    <div class="ak-button-group flex-grow-1">
                        <ak-widget
                            v-for="widget in idleWidgets.list"
                            :key="widget.id"
                            :type="widget.type"
                            :attributes="{...widget.attributes, id: widget.id}"
                            :slot="widget.slot"
                            :callbacks="widget.callbacks"
                            :callbackUri="baseGridUri"
                            :contextType="idleWidgets.contextType"
                            @new="handleNew"
                        />

                        <ak-button
                            :disableBackground="true"
                            class="m-l-auto"
                            @click.prevent="cancel"
                        >
                            {{ $t('Annuleren') }}
                        </ak-button>
                        <ak-button @click.prevent="save">
                            {{ $t('Opslaan') }}
                        </ak-button>
                    </div>
                </div>
            </template>
        </ak-data-table>

        <ak-relation-resolver
            v-if="childRelationString"
            :relationString="childRelationString"
            @close="triggerClose"
            @refresh="refresh"
        />
    </div>
</template>

<script>
export default {
    name: 'ak-stock-relation-data-table',
    props: {
        type: {
            type: String,
            required: true,
        },
        definition: {
            type: String,
            required: true,
        },
        bundle: {
            type: String,
            required: true,
        },
        relation: {
            type: String,
            default: '',
            required: true,
        },
        childRelationString: {
            type: String,
            required: false,
        },
        defaultIdsSelected: {
            type: Array,
            default: () => [],
        },
        filterOrderId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            idsSelected: this.defaultIdsSelected,
        };
    },
    computed: {
        queryForRelationTable() {
            const query = {
                originalObjectId: this.$route.params.objectId,
            };

            if (this.filterOrderId) {
                query.stockOrderId = this.filterOrderId;
            }

            return query;
        },
        isListView() {
            return this.type === 'list';
        },
    },
    watch: {
        childRelationString(childRelationString) {
            if (childRelationString === undefined && this.$refs.dataTable) {
                this.$refs.dataTable.refresh();
                this.$refs.dataTable.refreshParam += 1;
            }
        },
    },
    methods: {
        updateSelection(selectedIds) {
            this.idsSelected = selectedIds;
        },
        refresh() {
            this.$emit('refresh', this.defaultIdsSelected);
        },
        save() {
            this.$emit('save', this.idsSelected);
            this.$emit('close');
        },
        cancel() {
            this.$emit('close');
        },
        updateRelationString(data) {
            const params = {...this.$route.params};
            params.relationString += `:form:${data.bundleId}:${data.definitionId}:${data.objectId}`;
            this.$router.push({
                name: this.$route.name,
                params,
                query: this.$route.query,
            });
        },
        triggerClose() {
            this.$router.back();
        },
    },
};
</script>
